
import { Mail, Phone, Clock } from 'lucide-react';

const Contact = () => {
  return (
    <section id="contact" className="py-8 px-4">
      <div className="container mx-auto max-w-4xl">
        <div className="text-center mb-6">
          <h2 className="text-2xl md:text-3xl font-bold text-primary-dark mb-2">Get In Touch</h2>
        </div>

        <div className="grid md:grid-cols-3 gap-4">
          <div className="text-center p-4 bg-white rounded-lg shadow-md">
            <Phone className="text-primary-dark mx-auto mb-2" size={20} />
            <h3 className="text-sm font-medium text-primary-dark mb-1">Call or Text</h3>
            <p className="text-sm text-gray-700">7135104442</p>
          </div>

          <div className="text-center p-4 bg-white rounded-lg shadow-md">
            <Mail className="text-primary-dark mx-auto mb-2" size={20} />
            <h3 className="text-sm font-medium text-primary-dark mb-1">Email Us</h3>
            <p className="text-sm text-gray-700">info@nearlabservices.com</p>
          </div>

          <div className="text-center p-4 bg-white rounded-lg shadow-md">
            <Clock className="text-primary-dark mx-auto mb-2" size={20} />
            <h3 className="text-sm font-medium text-primary-dark mb-1">Business Hours</h3>
            <p className="text-xs text-gray-700">Mon-Fri: 8am-6pm · Sat: 9am-2pm</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
